import axios from "@/utils/request"

/**
 * @function getClientdataApi  => 配置信息
 */
export function getClientdataApi() {
    return axios({
        url: "/api/getClientdata",
        method: "GET",
    })
}

/**
 * @function getPageviewApi  => 页面信息
 */
export function getPageviewApi() {
    return axios({
        url: "/api/getPageview",
        method: "GET",
    })
}

/**
 * @function addDiacrisisApi  => 提交预约
 * 
 * @param    data         发送的参数
 */
export function addDiacrisisApi(data) {
    return axios({
        url: "/api/addDiacrisis",
        method: "POST",
        data: data
    })
}

/**
 * @function getRigDetailApi  => 预约详情
 * 
 * @param    data         发送的参数
 */
export function getRigDetailApi(data) {
    return axios({
        url: "/api/getRigDetail",
        method: "POST",
        data: data
    })
}